const ExpressionTemplate = {
  field: null,
  operator: null,
  value: '',
  valueType: 'value'
};

export default ExpressionTemplate;
